import React from 'react';
import { motion } from 'framer-motion';
export function HeroSection() {
  return <section className="relative min-h-[90vh] flex flex-col items-center justify-center overflow-hidden bg-gradient-to-b from-cream to-blush-light py-12 px-6" data-id="element-54">
      {/* Subtle background glow */}
      <div className="absolute inset-0 bg-hero-glow opacity-50 pointer-events-none" data-id="element-55" />

      {/* Edición Limitada Top Banner */}
      <motion.div initial={{
      opacity: 0,
      y: -20
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.8,
      ease: 'easeOut'
    }} className="relative z-20 w-full flex justify-center mb-8 lg:mb-10" data-id="element-56">
        <motion.a href="#oferta" animate={{
        boxShadow: ['0 0 0px rgba(191,155,48,0.2)', '0 0 20px rgba(191,155,48,0.4)', '0 0 0px rgba(191,155,48,0.2)']
      }} transition={{
        duration: 2.5,
        repeat: Infinity,
        ease: 'easeInOut'
      }} whileHover={{
        scale: 1.05
      }} whileTap={{
        scale: 0.97
      }} className="inline-flex items-center gap-2 px-6 py-2.5 bg-gradient-to-r from-gold-dark via-gold to-gold-bright text-burgundy-deep font-[Cinzel,_serif] font-bold tracking-[0.15em] uppercase text-sm rounded-full border border-gold-bright/50 shadow-lg cursor-pointer transition-all duration-300" data-id="element-57">
          <span className="text-base" data-id="element-58">🔥</span>
          <span data-id="element-59">Edición Limitada</span>
        </motion.a>
      </motion.div>

      <div className="max-w-6xl mx-auto w-full grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20 items-center relative z-10" data-id="element-60">
        {/* Image Column - Appears first on mobile */}
        <motion.div initial={{
        opacity: 0,
        y: 30,
        rotate: -2
      }} animate={{
        opacity: 1,
        y: 0,
        rotate: 2
      }} transition={{
        duration: 1.2,
        ease: 'easeOut'
      }} className="order-1 lg:order-2 relative mx-auto w-full max-w-md lg:max-w-full" data-id="element-61">
          <div className="relative aspect-[4/5] w-full rounded-sm overflow-hidden shadow-2xl shadow-burgundy-deep/20 border border-gold/20" data-id="element-62">
            <img src="https://cdn.magicpatterns.com/uploads/9JswDS6959R6gFo2K5r1ka/ChatGPT_Image_Mar_11,_2026,_04_45_22_PM.png" alt="Deseo & Intimidad: El Renacimiento - Libro" className="w-full h-full object-cover object-center" data-id="element-63" />
            {/* Soft overlay to blend image slightly */}
            <div className="absolute inset-0 bg-gradient-to-tr from-burgundy-deep/10 to-transparent mix-blend-overlay" data-id="element-64" />
          </div>

          {/* Decorative background element */}
          <div className="absolute -inset-4 border border-gold/30 rounded-sm -z-10 transform -rotate-2 translate-x-2 translate-y-2" data-id="element-65" />
        </motion.div>

        {/* Text Column */}
        <motion.div initial={{
        opacity: 0,
        x: -30
      }} animate={{
        opacity: 1,
        x: 0
      }} transition={{
        duration: 1,
        delay: 0.2,
        ease: 'easeOut'
      }} className="order-2 lg:order-1 flex flex-col items-center lg:items-start text-center lg:text-left" data-id="element-66">
          <motion.span initial={{
          opacity: 0
        }} animate={{
          opacity: 1
        }} transition={{
          delay: 0.8,
          duration: 1
        }} className="text-gold-bright tracking-[0.2em] uppercase font-semibold mb-6 text-[20px] font-[Cinzel,_serif]" data-id="element-67">
            Un Viaje de Retorno a Ti
          </motion.span>

          <h1 className="md:text-6xl lg:text-7xl font-playfair text-burgundy-deep mb-6 text-balance text-[64px]" data-id="element-68">
            Deseo & Intimidad: <br data-id="element-69" />
            <span className="font-cormorant italic text-gold font-light" data-id="element-70">
              El Renacimiento
            </span>
          </h1>

          <p className="md:text-xl text-charcoal/80 font-lora mb-10 max-w-xl text-[20px]" data-id="element-71">
            El protocolo somático de 21 días para apagar el modo supervivencia,
            resetear tu sistema nervioso y reclamar el magnetismo que el estrés
            te robó.
          </p>

          <motion.button onClick={() => {
          const el = document.getElementById('oferta');
          if (el) el.scrollIntoView({
            behavior: 'smooth',
            block: 'center'
          });
        }} whileHover={{
          scale: 1.02,
          boxShadow: '0 10px 30px -10px rgba(123, 45, 62, 0.4)'
        }} whileTap={{
          scale: 0.98
        }} className="inline-flex items-center justify-center px-8 py-4 bg-burgundy text-cream font-playfair tracking-wide text-lg rounded-xl shadow-lg shadow-burgundy/20 transition-all duration-300 border border-burgundy-light/50 overflow-hidden relative group cursor-pointer" data-id="element-72">
            <span className="relative z-10" data-id="element-73">RECLAMAR MI MAGNETISMO AHORA</span>
            <div className="absolute inset-0 bg-gradient-to-r from-burgundy via-burgundy-light to-burgundy opacity-0 group-hover:opacity-100 transition-opacity duration-500" data-id="element-74" />
          </motion.button>
        </motion.div>
      </div>
    </section>;
}